<template>
    <div class="d-flex">
        <div class="btn-group ms-auto">
          <div class="btn btn-sm btn-outline-primary" :class="{ active: type == 'bar' }" @click="locked ? null : type = 'bar'">Bar</div>
          <div class="btn btn-sm btn-outline-primary" :class="{ active: type == 'line' }" @click="locked ? null : type = 'line'">Line</div>
          <div class="btn btn-sm btn-outline-primary" :class="{ active: type == 'pie' }" @click="locked ? null : type = 'pie'">Pie</div>
        </div>
    </div>
    <canvas ref="canvas" width="400" height="200" class="mb-4"></canvas>
</template>

<script>


import Chart from 'chart.js';

export default {
    props: ["chartdata"],
    data() {
        return {
            chart: null,
            type: "bar",
            locked: false,
            animationDuration: 700
        }
    },
    mounted() {
        this.chart = this.create();
    },
    methods: {
        create() {
            return new Chart(this.$refs.canvas, this.config);
        },
        update() {
            if (this.chart) {
                if (! this.locked) {
                    this.locked = true;
                    this.chart.destroy();
                    this.chart = this.create();
                    setTimeout(() => {
                        this.locked = false;
                    }, this.animationDuration + 100);
                }
            }
        }
    },
    computed: {
        config() {
            return {
                type: this.type,
                data: {
                    labels: this.xdata,
                    datasets: [{
                        label: '',
                        data: this.ydata,
                        backgroundColor: this.colors,
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    legend: {
                        display: false
                    },
                    animation: {
                        duration: this.animationDuration
                    }
                }
            }
        },
        xdata() {
            return Object.keys(this.chartdata);
        },
        ydata() {
            return Object.values(this.chartdata);
        },
        colors() {
            return Object.keys(this.chartdata).map(() => 'rgba(0, 100, 250, 0.5)');
        }
    },
    watch: {
        chartdata() {
            this.update();
        },
        type() {
            this.update();
        }
    }
}
</script>